<style src="./styles.scss" lang="scss" scoped></style>
<template>
  <div class="item" :class="[{ expense: !isReceive(movement) }]">
    <h3 class="description">Descrição {{ movement.description }}</h3>
    <div class="sector">
      <div class="center-text">
        <label for="">Pagamento:</label>
        <p>{{ movement.paymentType }}</p>
      </div>
      <div class="center-text">
        <label for="">Conta origem</label>
        <p>{{ movement.account.name }}</p>
      </div>
      <div class="center-text" v-if="movement.transferredTo">
        <label for="">Trasferido para</label>
        <p>{{ movement.transferredTo.name }}</p>
      </div>
    </div>
    <div class="sector">
      <div class="center-text">
        <label for="">Saldo anterior</label>
        <p class="amount">
          R$ {{ movement.beforeBalance | totalToCurrencyBR }}
        </p>
      </div>
      <div class="center-text">
        <label for="">Valor do movimento</label>
        <p class="amount">R$ {{ movement.amount | totalToCurrencyBR }}</p>
      </div>
      <div class="center-text">
        <label for="">Saldo posterior</label>
        <p class="amount">R$ {{ movement.afterBalance | totalToCurrencyBR }}</p>
      </div>
    </div>
    <div class="date-footer">
      <div class="data-content">
        <label for="">Pagamento</label>
        <p>
          {{ movement.paymentDate | DateBR }}
        </p>
      </div>
      <div class="data-content">
        <label for="">Vencimento</label>
        <p>
          {{ movement.expiration | DateBR }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    movement: {},
    account: {
      type: String,
      default: '',
    },
  },
  filters: {
    totalToCurrencyBR(value) {
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
    DateBR(dt) {
      return new Date(dt).toLocaleString('pt-br');
    },
  },
  methods: {
    isReceive(movement) {
      if (movement.type === 'receive') {
        return true;
      }
      if (movement.type === 'expense') {
        return false;
      }

      if (String(movement.account._id) == String(this.account)) {
        return false;
      }
      return true;
    },
  },
};
</script>